import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "confirmation",
  templateUrl: "./confirmation.component.html",
})
export class ConfirmationComponent {

  @Input() public question: string;
  @Input() public buttonName = "Delete";
  @Input() public showTrashIcon = false;
  @Input() public inverseColor = false;
  @Input() public showTextBtn = false;
  @Input() public extraClasses = "false";
  @Input() public noStyle = false;
  @Output() public isConfirmed = new EventEmitter();
  public showModal = false;

  public handleConfirm(value) {
    if (value) {
      this.isConfirmed.emit(true);
    } else {
      this.isConfirmed.emit(false);
    }
    this.showModal = false;
  }
}
